module.exports = __webpack_public_path__ + "static/media/main_header.6720d2b9.png";